// NOTICE: KAPTION-INTEGRATION
// usage-analytics.TOKEN.1 — API client for the analytics token endpoint.
// Cloned from api/aiStudio.js. Account-scoped: hits
// GET /api/v1/accounts/:account_id/usage_analytics/token.
import ApiClient from './ApiClient';

class UsageAnalytics extends ApiClient {
  constructor() {
    super('usage_analytics', { accountScoped: true });
  }

  fetchToken(params = {}) {
    return this.show('token', params);
  }
}

export default new UsageAnalytics();
